import { FormFieldAny } from '@/components/FormField';
import { useTranslation } from 'react-i18next';

interface ReadonlyVersionInfoViewProps {
  versionString: string;
  resolvedType: string;
  resolvedCountry: string;
  fileUploaded: boolean;
  showFile?: boolean;
  // Hidden when the parent renders its own editable version field instead.
  showVersion?: boolean;
}

export function ReadonlyVersionInfoView({
  versionString,
  resolvedType,
  resolvedCountry,
  fileUploaded,
  showFile = true,
  showVersion = true,
}: ReadonlyVersionInfoViewProps) {
  const { t } = useTranslation();

  return (
    <>
      {showVersion && (
        <FormFieldAny
          labelKey="firmware.sidePanel.versionName"
          label={t('firmware.sidePanel.versionName')}
        >
          <input
            type="text"
            value={versionString}
            disabled
            className="w-full py-2 px-3 text-sm rounded-lg border border-border bg-surface-darker text-muted-foreground"
          />
        </FormFieldAny>
      )}

      <FormFieldAny
        labelKey="firmware.sidePanel.type"
        label={t('firmware.sidePanel.type')}
      >
        <input
          type="text"
          value={resolvedType}
          disabled
          className="w-full py-2 px-3 text-sm rounded-lg border border-border bg-surface-darker text-muted-foreground"
        />
      </FormFieldAny>


      <FormFieldAny
        labelKey="firmware.sidePanel.country"
        label={t('firmware.sidePanel.country')}
      >

        <input
          type="text"
          value={resolvedCountry}
          disabled
          className="w-full py-2 px-3 text-sm rounded-lg border border-border bg-surface-darker text-muted-foreground"
        />
      </FormFieldAny>

      {showFile && (
        <FormFieldAny
          labelKey="firmware.sidePanel.file"
          label={t('firmware.sidePanel.file')}
        >
          <p className="text-sm text-muted-foreground">
            {fileUploaded
              ? t('firmware.sidePanel.fileUploaded')
              : t('firmware.sidePanel.noFile')}
          </p>
        </FormFieldAny>
      )}
    </>
  );
}
